/* cart-discount-shared.js
 * 折扣码共用逻辑：同时服务于飞层购物车（atc-banner）
 * 和购物车页（static-cart）。只加载一次，作用于 DOM 中
 * 所有 .atc-discount-section 容器。
 */
(function () {
  if (window.__cartDiscountLoaded) return;
  window.__cartDiscountLoaded = true;

  var _dcApplied = [];
  var _dcInvalidCodeText = 'Enter a valid discount code or gift card';

  /* ── 工具函数 ────────────────────────────────────────────────────── */

  function _dcMoney(c) {
    return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function _dcCents(value) {
    var parsed = parseInt(value, 10);
    return isFinite(parsed) ? parsed : 0;
  }

  function _dcSumAllocations(allocations) {
    var total = 0;
    if (!Array.isArray(allocations)) return 0;
    for (var i = 0; i < allocations.length; i++) {
      total += _dcCents(
        allocations[i] && (
          allocations[i].amount ||
          allocations[i].total_allocated_amount ||
          allocations[i].discounted_amount
        )
      );
    }
    return total;
  }

  function _dcGetCartDiscount(cart) {
    var items = cart && cart.items || [];
    var apps = []
      .concat(cart && cart.cart_level_discount_applications || [])
      .concat(cart && cart.discount_applications || []);
    var discount = _dcCents(cart && cart.total_discount);
    var allocated = _dcSumAllocations(apps);
    var lineDiscount = 0;
    var item;

    if (discount > 0) return discount;
    if (allocated > 0) return allocated;

    for (var i = 0; i < items.length; i++) {
      item = items[i] || {};
      lineDiscount += _dcCents(item.total_discount || item.line_level_total_discount);
      lineDiscount += _dcSumAllocations(item.line_level_discount_allocations);
      lineDiscount += _dcSumAllocations(item.discount_allocations);
      lineDiscount += _dcSumAllocations(item.discounts);
    }

    if (lineDiscount > 0) return lineDiscount;

    return 0;
  }

  function _dcWriteMoney(el, cents, setMoney) {
    if (!el) return;
    if (setMoney) {
      el.textContent = ''; // 同 auxito-cart-drawer.js setMoney：setMoney 在没有 Shopify.formatMoney 的页面会静默失败，先清空才能走下面的兜底
      setMoney(el, cents);
    }
    if (!String(el.textContent || '').trim()) {
      el.textContent = _dcMoney(cents);
    }
  }

  function _dcGetLatestCart() {
    var c = window._auxitoLatestCart;
    return c && c.items ? c : null;
  }

  function _dcIsCartRateLimited() {
    var until = parseInt(window._auxitoCartRateLimitedUntil || 0, 10);
    return !!until && Date.now() < until;
  }

  function _dcMarkCartRateLimited(statusCode) {
    if (parseInt(statusCode, 10) === 429) {
      window._auxitoCartRateLimitedUntil = Date.now() + 3 * 60 * 1000;
      return true;
    }
    return false;
  }

  function _dcHideError(section) {
    if (!section) return;
    var errorEl = section.querySelector('.atc-discount-error');
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.style.display = 'none';
  }

  function _dcShowError(section, message) {
    if (!section) return;
    var errorEl = section.querySelector('.atc-discount-error');
    if (!errorEl) return;
    errorEl.textContent = message || _dcInvalidCodeText;
    errorEl.style.display = '';
  }

  function _dcHasApplicableCodes(discountCodes) {
    if (!Array.isArray(discountCodes)) return _dcApplied.length > 0;
    for (var i = 0; i < discountCodes.length; i++) {
      var c = discountCodes[i];
      if (c && c.applicable && c.code) return true;
    }
    return false;
  }

  function _dcUpdateInputAreaVisibility(discountCodes) {
    var hasApplicableCode = _dcHasApplicableCodes(discountCodes);
    var sections = document.querySelectorAll('.atc-discount-section');
    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      var inputArea = section.querySelector('.atc-discount-input-area');
      if (inputArea) inputArea.style.display = hasApplicableCode ? 'none' : '';
      if (hasApplicableCode) _dcHideError(section);
    }
  }

  /* 返回当前可见/最相关的 .atc-discount-section */
  function _dcGetActiveSection() {
    var all = document.querySelectorAll('.atc-discount-section');
    for (var i = all.length - 1; i >= 0; i--) {
      var el = all[i];
      if (el.offsetParent !== null || el.closest('[data-flyout-active]')) return el;
    }
    return all.length > 0 ? all[all.length - 1] : null;
  }

  /* 返回飞层横幅元素 */
  function _dcGetActiveBanner() {
    var b = document.querySelector('[data-flyout-active][data-atc-banner]');
    if (b) return b;
    var all = document.querySelectorAll('[data-atc-banner]');
    return all.length > 0 ? all[all.length - 1] : document;
  }

  /* ── 切换折叠状态 ─────────────────────────────────────── */

  function atcToggleDiscount(el) {
    var s = el ? el.closest('.atc-discount-section') : _dcGetActiveSection();
    if (!s) return;
    var b = s.querySelector('.atc-discount-body');
    var a = s.querySelector('.atc-discount-arrow');
    if (!b) return;
    var open = b.style.display !== 'none';
    b.style.display = open ? 'none' : '';
    if (a) a.classList.toggle('collapsed', open);
  }

  /* ── 应用折扣 ─────────────────────────────────────────────── */

  function atcApplyDiscount(el) {
    if (_dcIsCartRateLimited()) return;
    var s = el ? el.closest('.atc-discount-section') : _dcGetActiveSection();
    if (!s) return;
    var inp = s.querySelector('.atc-discount-input');
    var btn = s.querySelector('.atc-discount-apply-btn');
    var code = inp ? inp.value.trim().toUpperCase() : '';

    if (!code) return;
    if (_dcApplied.indexOf(code) !== -1) return;
    _dcHideError(s);

    if (btn) btn.textContent = '...';

    var all = _dcApplied.concat([code]);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: all.join(',') })
    })
    .then(function (r) {
      _dcMarkCartRateLimited(r && r.status);
      return r.json();
    })
    .then(function (cart) {
      window._auxitoLatestCart = cart;
      if (btn) btn.textContent = 'Apply';

      var codes = Array.isArray(cart && cart.discount_codes) ? cart.discount_codes : null;
      if (!codes) {
        _dcShowError(s, _dcInvalidCodeText);
        _dcUpdateInputAreaVisibility([]);
        if (inp) inp.value = '';
        return;
      }

      var matched = null;
      for (var i = 0; i < codes.length; i++) {
        var c = codes[i];
        if (c && c.code && c.code.toUpperCase() === code) {
          matched = c;
          break;
        }
      }

      if (!matched || !matched.applicable) {
        _dcShowError(s, _dcInvalidCodeText);
        if (inp) inp.value = '';
        _dcRenderAllContainers(codes);
        _dcUpdateInputAreaVisibility(codes);
        _dcUpdateAllContainers(cart);
        return;
      }

      if (_dcApplied.indexOf(code) === -1) _dcApplied.push(code);
      if (inp) inp.value = '';
      _dcHideError(s);
      _dcRenderAllContainers(codes);
      _dcUpdateInputAreaVisibility(codes);
      _dcUpdateAllContainers(cart);
    })
    .catch(function () {
      if (btn) btn.textContent = 'Apply';
      // 网络异常静默处理：不展示错误文案
    });
  }

  /* ── 移除折扣（清除所有折扣码） ────────────────────────── */

  function atcRemoveCode(evt) {
    if (_dcIsCartRateLimited()) return;
    var section = evt && evt.target && evt.target.closest ? evt.target.closest('.atc-discount-section') : _dcGetActiveSection();
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
    var prev = _dcApplied.slice();
    _dcApplied = [];
    _dcRenderAllContainers(null);
    _dcUpdateInputAreaVisibility([]);
    _dcHideError(section);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
    .then(function (r) {
      _dcMarkCartRateLimited(r && r.status);
      return r.json();
    })
    .then(function (cart) {
      window._auxitoLatestCart = cart;
      var codes = Array.isArray(cart && cart.discount_codes) ? cart.discount_codes : [];
      _dcRenderAllContainers(codes);
      _dcUpdateInputAreaVisibility(codes);
      _dcUpdateAllContainers(cart);
    })
    .catch(function () {
      _dcApplied = prev;
      _dcRenderAllContainers(null);
      _dcUpdateInputAreaVisibility(null);
      // 网络异常静默处理：不展示错误文案
    });
  }

  /* ── 在页面每个容器中渲染标签 ─────────────────── */

  function _dcRenderAllContainers(discountCodes) {
    var activeCodes = (discountCodes || []).filter(function (c) { return c && c.applicable; });
    var activeSet = {};
    for (var a = 0; a < activeCodes.length; a++) {
      activeSet[activeCodes[a].code.toUpperCase()] = true;
    }

    var renderList = discountCodes !== null
      ? _dcApplied.filter(function (c) { return activeSet[c]; })
      : _dcApplied;

    var tagContainers = document.querySelectorAll('.atc-discount-tags');
    for (var j = 0; j < tagContainers.length; j++) {
      var el = tagContainers[j];
      el.innerHTML = '';
      for (var i = 0; i < renderList.length; i++) {
        var c = renderList[i];
        var t = document.createElement('span');
        t.className = 'atc-discount-tag';
        t.appendChild(document.createTextNode(c + ' '));

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'atc-discount-tag-remove';
        removeBtn.textContent = '\u00D7';
        removeBtn.addEventListener('click', atcRemoveCode);

        t.appendChild(removeBtn);
        el.appendChild(t);
      }
    }

  }

  /* 保留以兼容旧逻辑（旧路径会传入特定 scope 调用） */
  function _dcRenderTags(scope, discountCodes) {
    _dcRenderAllContainers(discountCodes);
  }

  /* ── 更新每个容器中的小计/节省金额行 ──────────── */

  function _dcUpdateAllContainers(cart) {
    var disc = _dcGetCartDiscount(cart);
    var setMoney = typeof window.auxitoSetMoneyOnElement === 'function' ? window.auxitoSetMoneyOnElement : null;
    var refreshCurrency = typeof window.auxitoRefreshBannerCurrency === 'function' ? window.auxitoRefreshBannerCurrency : null;

    var allSavingsRows = document.querySelectorAll('.atc-discount-savings-row');
    for (var k = 0; k < allSavingsRows.length; k++) {
      var sr = allSavingsRows[k];
      var sa = sr.querySelector('.atc-discount-savings-amount');
      if (sa) {
        if (disc > 0) {
          sr.style.display = '';
          var inner = sa.querySelector('.money') || sa.querySelector('[data-atc-discount-amount]');
          if (inner) {
            _dcWriteMoney(inner, disc, setMoney);
          } else {
            sa.textContent = '-' + _dcMoney(disc);
          }
        } else {
          sr.style.display = 'none';
        }
      }
    }

    var allPriceEls = document.querySelectorAll('[data-atc-banner-cart-subtotal]');
    for (var m = 0; m < allPriceEls.length; m++) {
      if (setMoney) {
        setMoney(allPriceEls[m], cart.total_price);
      } else {
        allPriceEls[m].innerHTML = _dcMoney(cart.total_price);
      }
    }

    var discountedEls = document.querySelectorAll('.saso-cart-discounted-total');
    for (var p = 0; p < discountedEls.length; p++) {
      if (setMoney) {
        setMoney(discountedEls[p], cart.total_price);
      } else {
        discountedEls[p].innerHTML = _dcMoney(cart.total_price);
      }
    }

    if (refreshCurrency) refreshCurrency();
    else if (!setMoney && (allPriceEls.length > 0 || allSavingsRows.length > 0)) {
      setTimeout(function () {
        if (typeof window.auxitoSetMoneyOnElement !== 'function' || typeof window.auxitoRefreshBannerCurrency !== 'function') return;
        var cart = _dcGetLatestCart();
        if (!cart) return;
        var c = cart.total_price;
        var d = _dcGetCartDiscount(cart);
        var rows = document.querySelectorAll('.atc-discount-savings-row');
        for (var r = 0; r < rows.length; r++) {
          var sa = rows[r].querySelector('.atc-discount-savings-amount');
          if (sa) {
            var inner = sa.querySelector('.money') || sa.querySelector('[data-atc-discount-amount]');
            if (inner && d > 0) _dcWriteMoney(inner, d, window.auxitoSetMoneyOnElement);
          }
        }
        var subs = document.querySelectorAll('[data-atc-banner-cart-subtotal]');
        for (var s = 0; s < subs.length; s++) window.auxitoSetMoneyOnElement(subs[s], c);
        window.auxitoRefreshBannerCurrency();
      }, 400);
    }

    if (typeof window.auxitoSyncCartKeys === 'function') {
      window.auxitoSyncCartKeys(cart);
    } else {
      var items = (cart && cart.items) || [];
      var cartRows = document.querySelectorAll('[data-cartitem-id]');
      for (var r = 0; r < cartRows.length && r < items.length; r++) {
        cartRows[r].setAttribute('data-cartitem-id', items[r].key);
      }
      var banners = document.querySelectorAll('[data-atc-banner]');
      for (var bx = 0; bx < banners.length; bx++) {
        var products = banners[bx].querySelector('[data-atc-products]');
        if (!products) continue;
        var updates = products.querySelectorAll('[data-atc-banner-update]');
        var removes = products.querySelectorAll('[data-atc-remove-item]');
        for (var i = 0; i < items.length && i < updates.length; i++) {
          updates[i].setAttribute('data-product_id', items[i].key);
        }
        for (var i = 0; i < items.length && i < removes.length; i++) {
          removes[i].setAttribute('data-product_id', items[i].key);
        }
      }
    }
  }

  /* ── 同步新插入的横幅 ──────────────────────────────── */

  function _dcSyncBannerUI(banner) {
    if (!banner) return;
    var cached = _dcGetLatestCart();
    if (!cached) return;
    var cachedCodes = cached.discount_codes || [];
    _dcApplied = cachedCodes
      .filter(function (c) { return c.applicable; })
      .map(function (c) { return c.code.toUpperCase(); });
    _dcRenderAllContainers(cachedCodes);
    _dcUpdateInputAreaVisibility(cachedCodes);
    _dcUpdateAllContainers(cached);
  }

  /* ── 页面加载时初始化 ─────────────────────────────────────── */

  function _dcInit() {
    var cached = _dcGetLatestCart();
    if (cached) {
      var existingCodes = cached.discount_codes || [];
      _dcApplied = [];
      for (var j = 0; j < existingCodes.length; j++) {
        if (existingCodes[j].applicable) {
          _dcApplied.push(existingCodes[j].code.toUpperCase());
        }
      }
      _dcRenderAllContainers(existingCodes);
      _dcUpdateInputAreaVisibility(existingCodes);
      _dcUpdateAllContainers(cached);
      return;
    }
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window._auxitoLatestCart = cart;
        var codes = cart.discount_codes || [];
        _dcApplied = [];
        for (var i = 0; i < codes.length; i++) {
          if (codes[i].applicable) {
            _dcApplied.push(codes[i].code.toUpperCase());
          }
        }
        _dcRenderAllContainers(codes);
        _dcUpdateInputAreaVisibility(codes);
        _dcUpdateAllContainers(cart);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _dcInit);
  } else {
    _dcInit();
  }

  /* ── 购物车页：数量变化时同步折扣/节省金额 ─────── */
  (function () {
    var j = window.jQuery || window.$;
    if (!j) return;
    j(document).on('cartcount:update', function (ev, data) {
      if (data && data.response) {
        window._auxitoLatestCart = data.response;
        _dcUpdateInputAreaVisibility(data.response.discount_codes || []);
        _dcUpdateAllContainers(data.response);
      }
    });
  })();

  /* ── 回车键支持 ──────────────────────────────────────────── */

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.classList.contains('atc-discount-input')) {
      e.preventDefault();
      var section = e.target.closest('.atc-discount-section');
      var btn = section ? section.querySelector('.atc-discount-apply-btn') : null;
      atcApplyDiscount(btn || e.target);
    }
  });

  /* ── 监听动态添加的横幅 ───────────────────────── */

  var _dcSyncing = false;
  var _dcObserver = new MutationObserver(function (mutations) {
    if (_dcSyncing) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var k = 0; k < added.length; k++) {
        var n = added[k];
        if (n.nodeType !== 1 || (n.getAttribute && n.getAttribute('data-templates') !== null)) continue;
        var banner = (n.getAttribute && n.getAttribute('data-atc-banner') !== null)
          ? n
          : (n.querySelector && n.querySelector('[data-atc-banner]'));
        if (banner && !(banner.closest && banner.closest('[data-templates]'))) {
          _dcSyncing = true;
          _dcSyncBannerUI(banner);
          setTimeout(function () { _dcSyncing = false; }, 500);
          break;
        }
      }
    }
  });
  _dcObserver.observe(document.body || document.documentElement, { childList: true });

  /* ── 暴露到全局（供 onclick= 等属性调用） ───────────────── */

  window.atcToggleDiscount = atcToggleDiscount;
  window.atcApplyDiscount  = atcApplyDiscount;
  window.atcRemoveCode     = atcRemoveCode;
  /** 在任何购物车更新（改数量/加购/移除）后调用，用于刷新折扣行和小计。 */
  window.auxitoUpdateCartDiscount = function (cart) {
    if (!cart || !cart.items) return;
    window._auxitoLatestCart = cart;
    _dcUpdateInputAreaVisibility(cart.discount_codes || []);
    _dcUpdateAllContainers(cart);
  };

}());
